// extracted by mini-css-extract-plugin
export var container = "Form-module--container--J61mw";
export var labels = "Form-module--labels--yY-M-";